import { createSelector } from 'reselect'
import { SavePoint } from '../../Core'

// reexport the core save point selectors to make available to all game modules
export * from '../../Core/SavePoint/savePoint.selectors'

export const getStoryline = (state) => state.storyLine

export const getAlertData = createSelector(
  [SavePoint.selectors.getSavePoint, getStoryline],
  (savePoint, storyLine) => {
    let alertId = savePoint.alertData
    return storyLine.alerts[alertId] ? storyLine.alerts[alertId] : null
  }
)
export const getSettings = createSelector(
  [SavePoint.selectors.getSavePoint],
  (savePoint) => savePoint.settings
)
export const getCurrentTurn = createSelector([SavePoint.selectors.getSavePoint], (savePoint) => {
  return savePoint.currentTurn
})
export const isSurveyCompleted = createSelector(
  [SavePoint.selectors.getSavePoint],
  (savePoint) => savePoint.surveyFinished
)
